var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPushNotificationAvailable
    ? _c("div", { staticClass: "push-notification-box" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between w-100",
            },
            [
              _c("div", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm._f("trans")("Notification"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-muted" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("Get notified when the task is done"))
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-muted font-weight-bold" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "continue-btn-box" }, [
          _c(
            "div",
            {
              class: [
                _vm.emailNotify
                  ? "continue-btn-active"
                  : "continue-btn-inactive",
                !_vm.isRegisteredUser && "disabled",
              ],
              on: { click: _vm.handleEmailNotification },
            },
            [
              _c("div", { staticClass: "continue-btn-text" }, [
                _c("i", { staticClass: "far fa-envelope" }),
                _vm._v(" " + _vm._s(_vm._f("trans")("E-Mail"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.pushNotify
                ? "continue-btn-active"
                : "continue-btn-inactive",
              on: { click: _vm.handlePushNotification },
            },
            [
              _c("div", { staticClass: "continue-btn-text" }, [
                _c("i", { staticClass: "far fa-bell" }),
                _vm._v(" " + _vm._s(_vm._f("trans")("Push Notification"))),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }